import getWithToken from './base/get-with-token'

const getSignedUrl = (id, data) => getWithToken(`/import-dashboard-download-file/${id}`)(data)

export default getSignedUrl